export const EGG_TIMINGS = {
  slideUpMs: 800,
  crossfadeMs: 200,
  variantHoldMs: 1000,
  defaultHoldMs: 600,
  slideDownMs: 300,
} as const;

export const STORAGE_KEYS = {
  lastVariant: 'thm-self-like-last-variant',
} as const;

export const COPY_VARIATIONS = [
  'Self-love is the best love 💚',
  'Big fan of your own work 👌🏼',
  'Main character vibes!',
  'Congrats on you! I guess 😅',
  'You are your biggest fan 💪🏼',
] as const;
